"use memo"

import { TaskBlockerBlockerType } from '@urbanx/agx.activities.client'
import { IconTaskTypes } from '@urbanx/agx.ui-components2'
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge'
import { BlockerLayout } from 'pages/allTasks/TaskBlockers/BlockerLayout'
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry'
import { useTaskModalDialogState } from 'pages/allTasks/TaskModal/useTaskModalDialogState'
import {
  ExchangeTaskGroup,
  hasMarkedAsExchangeBlocker,
  requiresExchangeEvidence,
} from './ExchangeTask.shared'
import ExchangeTaskModal from './ExchangeTaskModal'

interface ExchangeTaskEntryProps {
  actionButtonId: string
  campaignId: string
  group: ExchangeTaskGroup
  panelKey: string
  title: string
}

const ExchangeTaskEntry = ({
  actionButtonId,
  campaignId,
  group,
  panelKey,
  title,
}: ExchangeTaskEntryProps) => {
  const modalState = useTaskModalDialogState(group.tasks)
  const task = group.informationTask ?? group.tasks[0]
  const isPendingExchangeEvidence = requiresExchangeEvidence(group)

  if (!task) return null

  const exchangeEvidenceTask =
    isPendingExchangeEvidence && group.family !== 'contract'
      ? {
          ...task,
          blockers: hasMarkedAsExchangeBlocker(task)
            ? task.blockers
            : [
                ...(task.blockers ?? []),
                {
                  blockerType: TaskBlockerBlockerType.MarkedAsExchanged,
                },
              ],
        }
      : undefined

  return (
    <>
      <ExchangeTaskModal
        campaignId={campaignId}
        family={group.family}
        isOpen={modalState.isOpen}
        onClose={modalState.close}
        tasks={modalState.modalTasks}
        title={title}
      />
      <TaskModalEntry
        title={title}
        tasks={group.tasks}
        badge={
          <TaskDueDateBadge
            dueDate={(task.dueUtc ?? '') as string}
            isCompleted={task.isCompleted === true}
          />
        }
        iconType={IconTaskTypes.AwaitingExchange}
        actionText="Complete Contract Exchange"
        actionButtonId={actionButtonId}
        panelKey={panelKey}
        blockerContent={
          exchangeEvidenceTask ? (
            <BlockerLayout task={exchangeEvidenceTask} />
          ) : undefined
        }
        onAction={modalState.open}
      />
    </>
  )
}

export default ExchangeTaskEntry
